import organization_role_list from './role-list';
import organization_role_add from './role-add';
import organization_role_edit from './role-edit';
import organization_role_detail from './role-detail';

export default {
    organization_role_list,
    organization_role_add,
    organization_role_edit,
    organization_role_detail,
};
